"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSocketIoContext = void 0;
const hermes_channel_1 = __importDefault(require("hermes-channel"));
const utils_1 = require("../utils");
const hooks_1 = require("./hooks");
const provider_1 = require("./provider");
const providerNativeFactory_1 = require("./provider/providerNativeFactory");
const SOCEKT_IO_SEND = "SOCEKT_IO_SEND";
function createSocketIoContext(options) {
    const events = [];
    const context = {
        connection: null,
        useSocketEffect: null,
        shareConnectionBetweenTab: (options === null || options === void 0 ? void 0 : options.shareConnectionBetweenTab) || false,
        invoke: (methodName, ...args) => {
            (0, utils_1.sendWithHermes)(SOCEKT_IO_SEND, { methodName, args }, context.shareConnectionBetweenTab);
        },
        Provider: null,
        on: (event) => {
            var _a;
            if (!events.includes(event)) {
                (_a = context.connection) === null || _a === void 0 ? void 0 : _a.on(event, (message) => {
                    (0, utils_1.sendWithHermes)(event, message, context.shareConnectionBetweenTab);
                });
            }
            events.push(event);
        },
        off: (event) => {
            var _a;
            if (events.includes(event)) {
                events.splice(events.indexOf(event), 1);
            }
            if (!events.includes(event)) {
                (_a = context.connection) === null || _a === void 0 ? void 0 : _a.off(event);
            }
        },
        //@ts-ignore
        reOn: () => {
            const uniqueEvents = (0, utils_1.removeDuplicates)(events);
            uniqueEvents.forEach((event) => {
                var _a;
                (_a = context.connection) === null || _a === void 0 ? void 0 : _a.on(event, (message) => {
                    (0, utils_1.sendWithHermes)(event, message, context.shareConnectionBetweenTab);
                });
            });
        },
    };
    context.Provider = context.shareConnectionBetweenTab
        ? (0, provider_1.providerFactory)(context)
        : (0, providerNativeFactory_1.providerNativeFactory)(context);
    context;
    context.useSocketEffect = (0, hooks_1.createUseSocketEffect)(context);
    hermes_channel_1.default.on(SOCEKT_IO_SEND, (data) => {
        var _a;
        if ((_a = context.connection) === null || _a === void 0 ? void 0 : _a.connected) {
            context.connection.emit(data.methodName, ...data.args);
        }
    });
    return context;
}
exports.createSocketIoContext = createSocketIoContext;
//# sourceMappingURL=context.js.map